import { defaultHelpMeNowQuestion, defaultProactiveSuggestionInterval, type TimelineFeatures } from "@expert/features";

export const features: TimelineFeatures = {
    helpMeNowQuestion: defaultHelpMeNowQuestion,
    isChatExpertAssistAutoCompleteEnabled: false,
    isChatProactiveSuggestionsEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
    isHelpMeNowEnabled: false,
    isOzmoIFrameEnabled: false,
    isProactiveGuidanceEnabled: false,
    isSimplrWebsocketLiveEnabled: false,
    isProactiveEnabled: false,
    isSalesFAQEnabled: false,
    isGroundedSearchExperimentEnabled: false,
    proactiveSuggestionInterval: defaultProactiveSuggestionInterval,
};
